export const NoResultsIcon = ({
  width = 29,
  height = 29,
  viewBox = '0 0 29 29',
  color = '#0E0E12',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
    >
      <path
        d="M16.75 9.25L9.25 16.75M9.25 9.25L16.75 16.75M27.9999 28.0003L21.5499 21.5503M25 13C25 19.6274 19.6274 25 13 25C6.37258 25 1 19.6274 1 13C1 6.37258 6.37258 1 13 1C19.6274 1 25 6.37258 25 13Z"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
